<template>
  <div class="grid gap-4">
    <!-- Loader -->
    <div class="col-12" v-if="loader">
      <ProgressBar mode="indeterminate" style="height: .5em" />
    </div>

    <!-- Vehículo -->
<div class="col-12 md:col-6">
  <div class="card flex flex-column gap-4 p-4 shadow-2 border-round">
    
    <!-- Encabezado -->
	<div class="text-xl font-bold mb-2 flex items-center gap-2">
		<i class="pi pi-car text-orange-500 mr-2 mt-1"></i> Vehículo
	</div>
    <p class="text-sm text-gray-600 mb-2">Encuentre aquí la información del vehículo.</p>

    <!-- Información -->
    <ul class="list-none p-0 m-0 text-sm">
      <li class="py-1">
        <span class="text-gray-500 font-medium">Placa:</span>
        <span class="text-blue-600 font-semibold">{{ Customer.vehiculo_placa ?? 'N/A' }}</span>
      </li>
      <li class="py-1">
        <span class="text-gray-500 font-medium">Clase:</span>
        <span class="text-900">{{ Customer.movimiento_claseveh ?? 'N/A' }}</span>
      </li>
    </ul>

    <!-- Imagen / Galería -->
    <div class="mt-3 text-center">
      <template v-if="img_vehiculo.length === 0">
        <Image :src="sinimagen" alt="Sin imagen" width="160" class="shadow-2 border-round" preview />
      </template>
      <template v-else>
        <Galleria 
          :value="img_vehiculo" 
          :responsiveOptions="galleriaResponsiveOptions" 
          :numVisible="3" 
          :circular="true" 
          containerClass="custom-galleria"
        >
          <template #item="{ item }">
            <img :src="item.url" :alt="item.identificacion" class="w-full border-round shadow-1" style="max-height: 220px; object-fit: cover;" />
          </template>
          <template #thumbnail="{ item }">
            <img :src="item.url" :alt="item.identificacion" class="w-4rem h-4rem border-round" style="object-fit: cover;" />
          </template>
        </Galleria>
      </template>
    </div>
  </div>
</div>
	

    
<div class="col-12 md:col-6">

	<!-- Conductor -->
    <div class="col-12 md:col-12">
      <div class="card flex flex-column md:flex-row gap-4 p-3">
        <div class="flex-1">
          <div class="text-xl font-bold mb-2 flex items-center gap-2">
            <i class="pi pi-user text-blue-500 mr-2 mt-1"></i> Conductor
          </div>
          <p class="text-sm text-gray-600 mb-3">Encuentre aquí la información del conductor.</p>
          <ul class="text-sm space-y-2">
            <li><span class="text-gray-500">Nombre:</span> {{ Customer.conductor_nombre ?? '' }}</li>
            <li><span class="text-gray-500">Cédula:</span> {{ Customer.conductor_documento ?? '' }}</li>
          </ul>
        </div>

        <div class="w-full md:w-4 text-center">
          <template v-if="img_conductor.length === 0">
            <Image :src="sinimagen" alt="Sin imagen" width="130" preview />
          </template>
          <template v-else-if="img_conductor.length === 1">
            <Image :src="img_conductor[0].url" alt="Conductor" width="130" preview />
          </template>
          <template v-else>
            <Galleria :value="img_conductor" :responsiveOptions="galleriaResponsiveOptions" :numVisible="3" :circular="true">
              <template #item="{ item }">
                <img :src="item.url" :alt="item.identificacion" class="w-full border-round" />
              </template>
              <template #thumbnail="{ item }">
                <img :src="item.url" :alt="item.identificacion" class="w-3rem" />
              </template>
            </Galleria>
          </template>
        </div>
      </div>
    </div>

	<!-- Asesor -->
	<div class="col-12 md:col-12">
		<div class="card p-3">
			<div class="text-xl font-bold mb-2 flex items-center gap-2">
			<i class="pi pi-user-edit text-green-600 mr-2 mt-1"></i> Asesor
			</div>
			<p class="text-sm text-gray-600 mb-3">Encuentre aquí la información del asesor.</p>
			<ul class="text-sm space-y-2">
			<li><span class="text-gray-500">Nombre:</span> {{ Customer.asesor_nombre ?? '' }}</li>
			<li><span class="text-gray-500">Cédula:</span> {{ Customer.asesor_documento ?? '' }}</li>
			</ul>
		</div>
	</div>

	<!-- Propietario -->
	<div class="col-12 md:col-12">
      <div class="card p-3">
        <div class="text-xl font-bold mb-2 flex items-center gap-2">
          <i class="pi pi-user-plus text-purple-500 mr-2 mt-1"></i> Propietario
        </div>
        <p class="text-sm text-gray-600 mb-3">Encuentre aquí la información del propietario.</p>
        <ul class="text-sm space-y-2">
          <li><span class="text-gray-500">Nombre:</span> {{ Customer.propietario_nombre }}</li>
          <li><span class="text-gray-500">Cédula:</span> {{ Customer.propietario_documento }}</li>
        </ul>
      </div>
    </div>

    </div>
  </div>
</template>


<script>
import { APIENDPOINTIMG } from '../../../app.config'
export default {
	data() {
		return {
			message: [],
			info_detalle_mov: [],
			customers: [],
			detalle_reme: [],
			details_remesa: [],
			code_seway: '',
			code_cumplido: '',
			sinimagen: [],
			list_cumplidos: [],
			list_sucursales: [],
			loader: false,
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
			loading: false,
		}
	},
	props: ['img_vehiculo','img_conductor','Customer'],
  mounted(){
		this.sinimagen = APIENDPOINTIMG+'img_profiles/profile.jpg';
	},
	methods:{

	}
};
</script>